// extracted by mini-css-extract-plugin
export const exchangeRateDisclaimer = "ExchangeRateDisclaimer-module--exchange-rate-disclaimer--1_GAO";